module.exports = __webpack_public_path__ + "img/teaching-room-bg.7d72cfc9.png";